/**
 * Order-execution timing — when a Buy / Sell / bot-Run order is sent
 * to market. Mirrors the trading-window choices the user expects from
 * Composer (Sergey 2026-05-21): execute immediately, wait for the next
 * intraday rebalance window, hold to the close, or wait for the next
 * session's open.
 */
export const TRADE_TIMING_OPTIONS = [
  "Now",
  "Next trading window",
  "End of the trading day",
  "First trading window"
] as const;

export type TradeTiming = (typeof TRADE_TIMING_OPTIONS)[number];

export const DEFAULT_TRADE_TIMING: TradeTiming = "Now";
